module.exports = __webpack_public_path__ + "static/media/logo_header.dd2b14ca.svg";